import { FC } from "react";

import AccordionLight from "../../../AccordionLight/";
import Config from "../Config/Config";
import { ArrawDownIcon } from "../../../icons/ArrawDownIcon";
import { ArrawUpIcon } from "../../../icons/ArrawUpIcon";

import styles from "./ConfigWithAccordion.module.css";



const ConfigWithAccordion: FC = () => {
  const renderHeader = (isOpen: boolean) => {
    return <p className={styles["header"]}>Settings {isOpen ? <ArrawUpIcon /> : <ArrawDownIcon />}</p>;
  };

  const renderContent = () => {
    return (
      <div className={styles["content"]}>
        <Config />
      </div>
    );
  };

  return (
    <AccordionLight
      classNameContainer={styles["config"]}
      classNameHeader={styles["config__header"]}
      classNameContent={styles["config__content"]}
      header={renderHeader}
      content={renderContent} />
  );
};

export default ConfigWithAccordion;
